import { googleGeocoder } from "./google";
import { hongKongGovGeocoder } from "./hongKongGov";

const allGeocoders = {
  google: googleGeocoder,
  hkgov: hongKongGovGeocoder,
};

export const GEOCODE_QUALITY_PROVIDED = "Provided";

export type HubGeocoderKey = keyof typeof allGeocoders;
export default allGeocoders;
